export const WAVELO_LIGHT_THEME_CONSTANTS = {
    FONTS: {
        headers: 'Wavehaus, sans-serif',
        body: 'ProximaNova, sans-serif'
    },
    COLOURS: {
        GREY: {
            grey_1: '#FAFAFA',
            grey_2: '#F5F5F5',
            grey_3: '#F0F0F0',
            grey_4: '#EBEBEB',
            grey_5: '#E0E0E0',
            grey_6: '#D1D1D1',
            grey_7: '#8C8C8C',
            grey_8: '#707070',
            grey_9: '#545454',
            grey_10: '#171717',
        },
        PRIMARY: {
            primary_1: '#532F63',
            primary_2: '#3F2446',
        },
        SECONDARY: {
            secondary_1: '#F7CA50',
            secondary_2: '#EFB824',
        },
        ERROR: {
            error_1: '#FF4747',
            error_2: '#E20000',
        }
    }
}
